import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import PageTitleBar from './PageTitleBar';
import styled from '@emotion/styled';
import { BreadcrumbProvider } from '../../contexts/BreadcrumbContext';

const Main = styled(Box)`
  flex-grow: 1;
  padding: 24px;
  transition: margin-left 0.3s, width 0.3s;
  margin-left: ${({ open }) => (open ? '0' : '-200px')};
`;

const ToolbarSpacer = styled('div')`
  margin-top: 128px;
`;

const BodyContainer = styled('div')`
  display: flex;
  
`;

const Layout = ({ children }) => {
    const [open, setOpen] = useState(true);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <BodyContainer>
          <BreadcrumbProvider>
            <Header toggleDrawer={toggleDrawer} />
            <PageTitleBar open={open} />
            <Sidebar open={open} />
            <Main open={open}>
                <ToolbarSpacer />
                {children}
            </Main>
           </BreadcrumbProvider>
        </BodyContainer>
    );
};

export default Layout;
